import React, { useEffect, useState } from "react";
import API from "libs/api";
import { useParams } from "react-router-dom";
import ICON from "components/cmp_icon/cmp_icon";

import CMP_CONTACT_READ from "./cmp_contact_read/cmp_contact_read";
import CMP_CONTACT_CREATE from './cmp_contact_create/cmp_contact_create';



export default function TAB_CONTACTS({ current_tab }) {

    //  variable declarations ------------------------------------------------------------------------------------------

    const { provider_id } = useParams();

    const [ var_data, set_data ] = useState([]);
    const [ var_processing, set_processing ] = useState('inactive');

    const [ var_contact_create_open, set_contact_create_open ] = useState(false);



    //  event listeners ------------------------------------------------------------------------------------------------

    useEffect(() => {
        if (current_tab === 'CONTACTS' && provider_id) {
            get_contacts();
        }
    }, [ current_tab, provider_id ]);



    //  async functions ------------------------------------------------------------------------------------------------

    async function get_contacts(){

        set_processing('processing');

        try {
            let results = await API_get_contacts();
            set_data(results.results === undefined ? [] : results.results);
            set_processing('inactive');
        } catch (e) {
            set_processing('error');
            console.log(e);
        }
    }



    //  API calls ------------------------------------------------------------------------------------------------------

    function API_get_contacts(){
        return API.get('admin-providers', '/get-provider-contacts/' + provider_id);
    }



    //  event functions ------------------------------------------------------------------------------------------------

    function onClick_create(){
        set_contact_create_open(true);
    }



    // RENDER CONTAINER ================================================================================================

    return (

        <div id='tab__page--provider_contacts' className='tab__page tab__transition'>

            <div className='card__wrapper'>
                {var_data.map(item =>
                    <CMP_CONTACT_READ
                        key={item.id}
                        contact={item}
                        onRefresh={get_contacts}
                    />
                )}

                <div className='card create' onClick={()=>onClick_create()}>
                    <div className='card__content'>
                        <ICON name='add' className='icon' alt='add icon'/>
                        <div>Add a new contact</div>
                    </div>
                </div>

            </div>

            <CMP_CONTACT_CREATE
                onOpen={var_contact_create_open}
                onClose={() => set_contact_create_open(false)}
                onRefresh={get_contacts}
            />

        </div>
    );
}
